// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "." + {"56":"6e328e3d","176":"67aca247","466":"e58343de"}[chunkId] + ".css";
};